export default "__VITE_ASSET__CRVsN$EG__"